import React from 'react'
import { Row, Col, Select } from 'antd'
import "./FinancialsFilters.css"

import API from '../api';
import { camelCaseToWords } from '../displayFormatters';
import { useQuery } from 'react-query';

const { Option } = Select;

export default function FinancialsFilters({ onChange }) {
  const filterDataQuery = useQuery({
    queryFn: () => loadFiltersData()
  })

  const [selectedFilters, setSelectedFilters] = React.useState({divisions: null, salesPersons: null, crewForeman: null})

  const filtersData = {
    divisions: filterDataQuery.data?.divisionsOptions ?? [],
    salesPersons: filterDataQuery.data?.salesPersonsOptions ?? [],
    crewForemen: filterDataQuery.data?.crewForemenOptions ?? [],
  }

  async function loadFiltersData() {
    const divisionsResponse = await API.get("web/divisions");
    const salesPersonsResponse = await API.get("users/sales");
    const crewForemenResponse = await API.get("users/foremen");

    return {
      divisionsOptions: divisionsResponse.data ? divisionsResponse.data.map(division => ({ key: division.id, name: division.name })) : [],
      salesPersonsOptions: salesPersonsResponse.data ? salesPersonsResponse.data.map(salesPerson => ({ key: salesPerson.email, name: salesPerson.displayName })) : [],
      crewForemenOptions: crewForemenResponse.data ? crewForemenResponse.data.map(crewForeman => ({ key: crewForeman.email, name: crewForeman.displayName })) : []
    }
  }

  function renderFilter(filterName) {
    return (
      <Select
        mode="multiple"
        allowClear
        style={{ width: '100%' }}
        placeholder={`Select ${camelCaseToWords(filterName)}`}
        optionFilterProp='children'
        onChange={(value) => handleChange(filterName, value)}
      >
        {renderFilterOptions(filterName)}
      </Select>
    )
  }

  function handleChange(filter, value) {
    const newSelection = {
      ...selectedFilters,
      [filter]: value.length ? value : null
    }
    setSelectedFilters(newSelection)
    onChange({
      divisionIds:newSelection.divisions,
      salesPersonEmails: newSelection.salesPersons,
      crewForemanEmails: newSelection.crewForemen
    })
  }

  function renderFilterOptions(filterName) {
    return filtersData[filterName] ? filtersData[filterName].map(filterOption => <Option key={filterOption.key}>{filterOption.name}</Option>) : null
  }

  return <div className="financials-filters">
    <Row>
      <Col span={8}>
        {renderFilter('divisions')}
      </Col>
      <Col span={8}>
        {renderFilter('salesPersons')}
      </Col>
      <Col span={8}>
        {renderFilter('crewForemen')}
      </Col>
    </Row>
  </div>
}
